import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import UploaderV2 from "@/components/default/UploaderV2.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import { formRules } from "@/js/form_rules.js";
export default {
  name: "EventDetails",
  props: ["loggedUserData", "id"],
  components: {
    UploaderV2: UploaderV2,
    Confirm: Confirm
  },
  data: function data() {
    return {
      editingEntity: {
        form: {
          id: null,
          eventUrl: null,
          logoUrl: null,
          firstParagraph: null,
          secondParagraphTitle: null,
          secondParagraph: null,
          leftText: null,
          leftTextLink: null,
          rightText: null,
          rightTextLink: null,
          bottomSmallerText: null,
          primaryButtonText: null,
          primaryButtonLink: null,
          footerParagraph: null,
          isPublicVisible: false,
          titleForAdmin: null,
          mailToTitle: null,
          mailToEmail: null,
          isValid: false
        },
        isPending: false,
        secondParagraphVisible: false,
        cancellationToken: null
      },
      gettingEvent: {
        isPending: false,
        cancellationToken: null
      },
      savingEvent: {
        isPending: false,
        cancellationToken: null
      },
      deletingEvent: {
        isPending: false,
        cancellationToken: null
      },
      gettingLogo: {
        isPending: false,
        cancellationToken: null
      },
      deletingLogo: {
        isPending: false,
        cancellationToken: null
      },
      addingLogo: {
        isPending: false,
        cancellationToken: null
      },
      dateMenu: null,
      textToCopy: "",
      copied: false,
      chaptersVisibility: {
        headerParagraph: true,
        essentialInfo: false,
        primaryAction: false,
        footerParagraph: false
      },
      formRules: formRules
    };
  },
  computed: {
    uploadLogoUrl: function uploadLogoUrl() {
      var id = this.$route.params.id;
      if (this.isAdding) {
        id = this.editingEntity.form.id;
      }
      return "".concat(process.env.VUE_APP_API_URL, "/v1/events/uploads/").concat(id, "/logo");
    },
    previewUrl: function previewUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/events/").concat(this.editingEntity.form.eventUrl);
    },
    isAdding: function isAdding() {
      return this.$route.params.id == 0;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.editingEntity.isPending || this.deletingLogo.isPending || this.addingLogo.isPending || this.savingEvent.isPending || this.deletingEvent.isPending;
    }
  },
  watch: {
    "editingEntity.form.date": function editingEntityFormDate(newVal) {
      this.editingEntity.form.date = new Date(newVal).formatForDatePickerDays();
    },
    "editingEntity.form.mailToTitle": function editingEntityFormMailToTitle(newVal) {
      if (!newVal) {
        this.editingEntity.form.mailToEmail = null;
      }
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.isAdding) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return _this2.getEvent();
          case 3:
            if (_this2.editingEntity.form.secondParagraph || _this2.editingEntity.form.secondParagraphTitle) {
              _this2.editingEntity.secondParagraphVisible = true;
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getEvent: function getEvent() {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$gettingEvent$c;
        var forcedId, id, _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              forcedId = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : null;
              _this3.gettingEvent.isPending = true;
              (_this3$gettingEvent$c = _this3.gettingEvent.cancellationToken) === null || _this3$gettingEvent$c === void 0 || _this3$gettingEvent$c.cancel();
              _this3.gettingEvent.cancellationToken = axios.CancelToken.source();
              id = _this3.$route.params.id;
              if (forcedId) {
                id = forcedId;
              }
              _this = _this3;
              _context2.next = 9;
              return request("/v1/events/".concat(id), "get", null, true, "api", _this.gettingEvent.cancellationToken).catch(function (_) {
                _this3.gettingEvent.isPending = false;
                _this.$toasted.show("Unable to get event.", {
                  type: "error"
                });
              });
            case 9:
              response = _context2.sent;
              _this3.editingEntity.form = _objectSpread(_objectSpread({}, _this.editingEntity.form), response.data.value);
              _this3.$nextTick(function () {
                _this3.gettingEvent.isPending = false;
                _this3.gettingEvent.cancellationToken = null;
              });
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getEventLogoUrl: function getEventLogoUrl() {
      var _arguments2 = arguments,
        _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$gettingLogo$ca;
        var forcedId, id, _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              forcedId = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : null;
              _this4.gettingLogo.isPending = true;
              (_this4$gettingLogo$ca = _this4.gettingLogo.cancellationToken) === null || _this4$gettingLogo$ca === void 0 || _this4$gettingLogo$ca.cancel();
              _this4.gettingLogo.cancellationToken = axios.CancelToken.source();
              id = _this4.$route.params.id;
              if (forcedId) {
                id = forcedId;
              }
              _this = _this4;
              _context3.next = 9;
              return request("/v1/events/".concat(id, "/logo"), "get", null, true, "api", _this.gettingLogo.cancellationToken).catch(function (_) {
                _this.gettingLogo.isPending = false;
                _this.$toasted.show("Unable to get event logo.", {
                  type: "error"
                });
              });
            case 9:
              response = _context3.sent;
              _this4.editingEntity.form.logoUrl = response.data.value;
              _this4.$nextTick(function () {
                _this4.gettingEvent.isPending = false;
                _this4.gettingEvent.cancellationToken = null;
              });
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    saveEvent: function saveEvent() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!_this5.isAdding) {
                _context4.next = 5;
                break;
              }
              _context4.next = 3;
              return _this5.addEvent();
            case 3:
              _context4.next = 7;
              break;
            case 5:
              _context4.next = 7;
              return _this5.updateEvent();
            case 7:
              _this5.$nextTick(function () {
                _this5.savingEvent.isPending = false;
                _this5.savingEvent.cancellationToken = null;
                _this5.updateParams();
                _this5.$toasted.show("Event saved.", {
                  type: "success"
                });
              });
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    addEvent: function addEvent() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this6$savingEvent$ca;
        var formCopy, formToSend, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.savingEvent.isPending = true;
              (_this6$savingEvent$ca = _this6.savingEvent.cancellationToken) === null || _this6$savingEvent$ca === void 0 || _this6$savingEvent$ca.cancel();
              _this6.savingEvent.cancellationToken = axios.CancelToken.source();
              formCopy = _objectSpread({}, _this6.editingEntity.form);
              formToSend = _this6.excludeKeys(formCopy, ["urlLogo", "isValid"]);
              _context5.prev = 5;
              _context5.next = 8;
              return request("/v1/events", "post", formToSend, true, "api", _this6.savingEvent.cancellationToken);
            case 8:
              response = _context5.sent;
              _this6.editingEntity.form.id = response.data.value;
              _context5.next = 12;
              return _this6.getEvent(response.data.value);
            case 12:
              if (_this6.editingEntity.form.logoUrl) {
                _context5.next = 17;
                break;
              }
              _context5.next = 15;
              return _this6.$refs.uploadLogoUrl.uploadAll(true);
            case 15:
              _context5.next = 17;
              return _this6.getEventLogoUrl(_this6.editingEntity.form.id);
            case 17:
              _context5.next = 23;
              break;
            case 19:
              _context5.prev = 19;
              _context5.t0 = _context5["catch"](5);
              _this6.savingEvent.isPending = false;
              _this6.$toasted.show("Unable to add event.", {
                type: "error"
              });
            case 23:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[5, 19]]);
      }))();
    },
    updateEvent: function updateEvent() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this7$savingEvent$ca;
        var formCopy, formToSend;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.savingEvent.isPending = true;
              (_this7$savingEvent$ca = _this7.savingEvent.cancellationToken) === null || _this7$savingEvent$ca === void 0 || _this7$savingEvent$ca.cancel();
              _this7.savingEvent.cancellationToken = axios.CancelToken.source();
              formCopy = _objectSpread({}, _this7.editingEntity.form);
              formToSend = _this7.excludeKeys(formCopy, ["urlLogo", "isValid"]);
              _context6.prev = 5;
              _context6.next = 8;
              return request("/v1/events", "put", formToSend, true, "api", _this7.savingEvent.cancellationToken);
            case 8:
              if (_this7.editingEntity.form.logoUrl) {
                _context6.next = 11;
                break;
              }
              _context6.next = 11;
              return _this7.$refs.uploadLogoUrl.uploadAll(true);
            case 11:
              _context6.next = 13;
              return _this7.getEvent();
            case 13:
              _context6.next = 19;
              break;
            case 15:
              _context6.prev = 15;
              _context6.t0 = _context6["catch"](5);
              _this7.savingEvent.isPending = false;
              _this7.$toasted.show("Unable to update event.", {
                type: "error"
              });
            case 19:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[5, 15]]);
      }))();
    },
    updateParams: function updateParams() {
      if (this.id) return;
      this.$router.push({
        name: "adminEventDetails",
        params: {
          id: this.editingEntity.form.id
        }
      });
    },
    confirmLogoDelete: function confirmLogoDelete() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this8.$refs.confirm.open("Delete event logo", "Are you sure to delete this logo ? Warning: This action cannot be undone.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(confirm) {
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        if (!confirm) {
                          _context7.next = 3;
                          break;
                        }
                        _context7.next = 3;
                        return _this8.logoDelete();
                      case 3:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    logoDelete: function logoDelete() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this9$deletingLogo$c;
        var id, _this;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this9.deletingLogo.isPending = true;
              (_this9$deletingLogo$c = _this9.deletingLogo.cancellationToken) === null || _this9$deletingLogo$c === void 0 || _this9$deletingLogo$c.cancel();
              _this9.deletingLogo.cancellationToken = axios.CancelToken.source();
              id = _this9.$route.params.id;
              _this = _this9;
              _context10.next = 7;
              return request("/v1/events/".concat(id, "/logo"), "delete", null, true, "api", _this.deletingLogo.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        _this.deletingLogo.isPending = false;
                        _this.deletingLogo.cancellationToken = null;
                        errorData = getErrorData(e, {}, "Unable to delete the image.", true);
                        handleErrorData(_this, errorData);
                        throw e;
                      case 5:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 7:
              _this9.editingEntity.form.logoUrl = null;
              _this9.$toasted.show("Image deleted.", {
                type: "success"
              });
              _this9.$nextTick(function () {
                _this9.deletingLogo.isPending = false;
                _this9.deletingLogo.cancellationToken = null;
              });
            case 10:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    copyText: function copyText() {
      var _this10 = this;
      navigator.clipboard.writeText(this.getUniqueEventUrl()).then(function () {
        _this10.copied = true;
        setTimeout(function () {
          _this10.copied = false;
        }, 1000);
      });
    },
    cancelEvent: function cancelEvent() {
      this.$router.push({
        name: "adminEventList"
      });
    },
    deleteEvent: function deleteEvent() {
      var _this11 = this;
      this.$refs.confirm.open("Delete event", "Are you sure to delete this event ? Warning: This action cannot be undone.", {
        color: "red"
      }).then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(confirm) {
          var _this11$deletingEvent, id, _this;
          return _regeneratorRuntime().wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                if (!confirm) {
                  _context12.next = 10;
                  break;
                }
                id = _this11.$route.params.id;
                _this11.deletingEvent.isPending = true;
                (_this11$deletingEvent = _this11.deletingEvent.cancellationToken) === null || _this11$deletingEvent === void 0 || _this11$deletingEvent.cancel();
                _this11.deletingEvent.cancellationToken = axios.CancelToken.source();
                _this = _this11;
                _context12.next = 8;
                return request("/v1/events/".concat(id), "delete", null, true, "api", _this.deletingEvent.cancellationToken).catch(/*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(e) {
                    var errorData;
                    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                      while (1) switch (_context11.prev = _context11.next) {
                        case 0:
                          _this.deletingEvent.isPending = false;
                          _this.deletingEvent.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to delete the event.", true);
                          handleErrorData(_this, errorData);
                          throw e;
                        case 5:
                        case "end":
                          return _context11.stop();
                      }
                    }, _callee11);
                  }));
                  return function (_x4) {
                    return _ref4.apply(this, arguments);
                  };
                }());
              case 8:
                _this11.$toasted.show("Event deleted.", {
                  type: "success"
                });
                _this11.$nextTick(function () {
                  _this11.deletingEvent.isPending = false;
                  _this11.deletingEvent.cancellationToken = null;
                  _this11.$router.push({
                    name: "adminEventList"
                  });
                });
              case 10:
              case "end":
                return _context12.stop();
            }
          }, _callee12);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    openUrl: function openUrl(url) {
      window.open(url, "_blank");
    },
    getUniqueEventUrl: function getUniqueEventUrl() {
      return window.location.origin + "/events/" + this.editingEntity.form.eventUrl;
    },
    excludeKeys: function excludeKeys(obj, keys) {
      return Object.fromEntries(Object.entries(obj).filter(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
          key = _ref6[0];
        return !keys.includes(key);
      }));
    },
    resetFormValidation: function resetFormValidation() {
      this.$refs.form.resetValidation();
    },
    resetSecondParagraph: function resetSecondParagraph() {
      if (!this.editingEntity.secondParagraphVisible) {
        this.editingEntity.form.secondParagraphTitle = null;
        this.editingEntity.form.secondParagraph = null;
      }
    }
  }
};